import React, { useMemo } from "react";

import { Box, Modal, Text } from "@catchoftheday/cg-components";
import { date } from "@catchoftheday/utilities";

import { Coupon } from "../types";

type CouponDetailsModalProps = Coupon & {
  isOpen: boolean;
  displayName?: string;
  handleModalClose: () => void;
};

export const CouponDetailsModal = ({
  isOpen,
  displayName,
  code,
  toDate,
  salesRule: { shortDescription, longDescription },
  handleModalClose,
}: CouponDetailsModalProps) => {
  const offerExpiryDate = useMemo(() => {
    const expiryDate = new Date(toDate);
    if (!date.isValid(expiryDate)) {
      return null;
    }

    return date.format(expiryDate, "hh:mmaaa dd/MM/yy");
  }, [toDate]);

  return (
    <Modal
      isOpen={isOpen}
      width={["85%", null, "500px"]}
      zIndex={5}
      contentProps={{ p: "20px" }}
      onClose={handleModalClose}
      onRequestClose={handleModalClose}
      ariaHideApp={false}
    >
      <Box
        p="20px"
        mb="15px"
        border="1px dashed"
        borderColor="ui.borderColor"
        borderRadius="default"
      >
        <Box textAlign="center" color="secondary" mb="14px">
          <Text as="span" fontWeight="medium">
            {displayName ? `Hey ${displayName},` : "Hey!"}{" "}
          </Text>
          {shortDescription && (
            <Text as="span" fontWeight="medium" textTransform="lowercase">
              {shortDescription}{" "}
            </Text>
          )}
        </Box>
        <Text
          as="div"
          mb="14px"
          fontSize="xl"
          fontWeight="medium"
          textAlign="center"
        >
          Use code{" "}
          <Text
            as="span"
            p="5px"
            fontSize="xl"
            fontWeight="medium"
            textTransform="uppercase"
            color="secondary"
            border="1px solid"
            borderRadius="default"
            borderColor="ui.borderColor"
          >
            {code}
          </Text>{" "}
          at checkout
        </Text>
        {offerExpiryDate && (
          <Text mb="0px" fontSize="xs" textAlign="center">
            {`Offer valid until ${offerExpiryDate}`}
          </Text>
        )}
      </Box>
      {longDescription && (
        <Text mb="0px" fontSize="2xs" color="typography.subText">
          {longDescription}
        </Text>
      )}
    </Modal>
  );
};
